import { useIntl } from 'react-intl';

const useFormatMessage: () => (id: string) => string = () => {
  const { formatMessage } = useIntl();

  return (id: string) => formatMessage({ id });
};

export default useFormatMessage;
